import type { SendEmailRequest } from "@forgepoint/shared";
import { LinkifiedText } from "@/components/LinkifiedText";
import { HtmlBodyRenderer } from "./EmailPreviewPanel";

interface SendEmailBodyProps {
  request: SendEmailRequest;
}

/**
 * Renders a SendEmail request's body in the rendering it was composed in.
 * @param props - The request whose body to render
 * @returns The rendered body
 */
export function SendEmailBody({ request }: SendEmailBodyProps) {
  if (!request.content) {
    return (
      <div className="text-sm italic text-muted-foreground">No email body</div>
    );
  }
  if (request.contentType === "html") {
    return <HtmlBodyRenderer html={request.content} />;
  }
  return (
    <div className="whitespace-pre-wrap break-words text-sm text-foreground">
      <LinkifiedText text={request.content} />
    </div>
  );
}
